import { cs } from '@formkit/i18n'

const config = {
  locales: { cs },
  locale: 'cs',
}

export default config